import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import LogoSepet from '../views/LogoSepet'
import Login from '@/views/Login'
import DashBoard from '@/views/DashBoard'
import ConsultaPedido from '@/views/ConsultaPedido.vue'
import ApiPrueba from '@/views/ApiPrueba.vue'
import GeocodePrueba from '@/views/GeocodePrueba.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/layouts/Default.vue'),
    children: [
      {
        path: '',
        name: 'home',
        props: true,
        component: LogoSepet
      },
      {
        path: 'login',
        name: 'login',
        component: Login
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: DashBoard
      },
      {
        path: 'consulta-pedido',
        name: 'consulta-pedido',
        component: ConsultaPedido
      },
      {
        path: 'apiprueba',
        name: 'apiprueba',
        component: ApiPrueba,
      },
      {
        path: 'geocode',
        name: 'geocode',
        component: GeocodePrueba
      },
      {
        path: 'about',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
      }
    ]
  },
  {
    path: '/otro',
    component: () => import('@/layouts/DefaultOtro.vue'),
    children: [
      {
        path: 'about',
        name: 'about2',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import( /* webpackChunkName: "about" */ '../views/About.vue')
      },
      {
        path: 'flexbox',
        name: 'flexbox',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import( /* webpackChunkName: "about" */ '../views/Flexbox.vue')
      }
    ]
  },
  {
    path: '/firma',
    component: () => import('@/layouts/Firma.vue'),
    children: [
      {
        path: 'firma',
        name: 'firma',
        component: () => import('@/views/RecogerFirma.vue')
      },
      {
        path: 'firma2',
        name: 'firma2',
        component: () => import('@/views/RecogerFirma2.vue')
      },
      {
        path: 'firma3',
        name: 'firma3',
        component: () => import('@/views/RecogerFirma3.vue')
      },
    ]
  }
]

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login', '/'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('userToken');

  if (authRequired && !loggedIn) {
    next({name: 'login'});
  } else if (to.name == 'login' && loggedIn) {
    next({name: 'home'});
    // next(false);
  } else next();
})

export default router
